import React from 'react';
import './PreviewPanels.css';

/*
 * Original concept preview for the Hugging Face Model Analytics Agent
 * (not a screenshot of a deployed app, and not real Hugging Face data).
 * Inline SVG at a 480x270 (16:9) design size so it shares the exact media slot
 * used by the real screenshots, with a large type scale so it stays readable
 * once the card narrows on mobile. Model names and values are obvious
 * placeholders and the panels say so, so nothing reads as a measured result.
 */

/* illustrative bar shape only, no claimed values */
const BARS = [24, 32, 20, 42, 30, 50];

function ModelAnalyticsPreview() {
  return (
    <svg
      className="preview-svg"
      viewBox="0 0 480 270"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
    >
      <rect width="480" height="270" fill="#f7f1e7" />

      {/* app header strip with a task filter control */}
      <g>
        <rect width="480" height="34" fill="#eee5d4" />
        <circle cx="21" cy="17" r="6" fill="#c8b8d8" />
        <text className="pv-t pv-strong" x="34" y="22">
          Model Analytics
        </text>
        <rect x="344" y="9" width="120" height="17" rx="8" fill="#e7eef3" stroke="#a9c7d8" strokeWidth="1" />
        <text className="pv-t pv-label" x="355" y="21">
          TASK: TEXT-GEN
        </text>
      </g>

      {/* natural-language query row */}
      <g>
        <rect x="12" y="42" width="378" height="34" rx="9" fill="#fffdf8" stroke="#c8b8d8" strokeWidth="1.4" />
        <text className="pv-t pv-dim" x="24" y="64">
          &gt;
        </text>
        <text className="pv-t" x="40" y="64">
          Which models gained activity?
        </text>
        <rect x="398" y="42" width="70" height="34" rx="9" fill="#a8be9a" />
        <text className="pv-t pv-btn" x="421" y="64">
          Ask
        </text>
      </g>

      {/* structured answer summary */}
      <g>
        <rect x="12" y="82" width="456" height="36" rx="8" fill="#e7eef3" stroke="#a9c7d8" strokeWidth="1.2" />
        <text className="pv-t pv-label" x="24" y="99">
          ANSWER SUMMARY
        </text>
        <text className="pv-t" x="24" y="113">
          Ranked by activity change, with a projection.
        </text>
      </g>

      {/* activity chart */}
      <g>
        <rect x="12" y="124" width="222" height="84" rx="8" fill="#fffdf8" stroke="#e6ddcb" strokeWidth="1.2" />
        <text className="pv-t pv-label" x="24" y="141">
          ACTIVITY BY WEEK
        </text>
        <line x1="24" y1="192" x2="222" y2="192" stroke="#e6ddcb" strokeWidth="1.2" />
        {BARS.map((height, index) => (
          <rect
            key={index}
            x={28 + index * 32}
            y={192 - height}
            width="20"
            height={height}
            rx="3"
            fill={index === 5 ? '#d6a65e' : '#e6c893'}
          />
        ))}
        <text className="pv-t pv-label" x="24" y="204">
          PLACEHOLDER VALUES
        </text>
      </g>

      {/* top models table */}
      <g>
        <rect x="246" y="124" width="222" height="84" rx="8" fill="#fffdf8" stroke="#e6ddcb" strokeWidth="1.2" />
        <text className="pv-t pv-label" x="258" y="141">
          TOP MODELS
        </text>
        <text className="pv-t pv-label" x="410" y="141">
          CHANGE
        </text>
        <line x1="258" y1="147" x2="456" y2="147" stroke="#e6ddcb" strokeWidth="1.2" />

        <text className="pv-t" x="258" y="164">
          model-alpha
        </text>
        <text className="pv-t pv-good" x="410" y="164">
          +18%
        </text>
        <line x1="258" y1="170" x2="456" y2="170" stroke="#f1e9d9" strokeWidth="1" />

        <text className="pv-t" x="258" y="184">
          model-beta
        </text>
        <text className="pv-t pv-good" x="410" y="184">
          +11%
        </text>
        <line x1="258" y1="190" x2="456" y2="190" stroke="#f1e9d9" strokeWidth="1" />

        <text className="pv-t" x="258" y="204">
          model-gamma
        </text>
        <text className="pv-t pv-dim" x="410" y="204">
          +4%
        </text>
      </g>

      {/* forecast panel */}
      <g>
        <rect x="12" y="214" width="456" height="46" rx="8" fill="#efeaf4" stroke="#c8b8d8" strokeWidth="1.2" />
        <text className="pv-t pv-label" x="24" y="232">
          FORECAST
        </text>
        <text className="pv-t pv-dim" x="24" y="250">
          Next 30 days, sample values
        </text>
        <path
          d="M300 250l26-7 26 5 26-10"
          fill="none"
          stroke="#8f78a8"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M378 238l26-4 26-5 26-3"
          fill="none"
          stroke="#8f78a8"
          strokeWidth="2.2"
          strokeDasharray="6 5"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}

export default ModelAnalyticsPreview;
